module.exports = __webpack_public_path__ + "static/img/jjc_forth.8fad64ab.png";